export class WithdrawalSummary {
  transaction: any;

  fromPage: string;
}

/*
 * Dummy service, for temporarily pass values to withdrawalSummary route
 */
angular.module('posApp').factory('withdrawalSummary', () => {
  return new WithdrawalSummary();
});
